module.exports = __webpack_public_path__ + "static/media/Oct17-F18.32918b91.png";